<template>
    <v-container class="pa-0" grid-list-md>
        <v-layout row>
            <v-flex>
                <v-btn-toggle
                    class="rounded-btn-group v-text-field--outline"
                    mandatory 
                    :value="selectedValue" 
                    @change="handleValueChanged">
                    <v-flex v-for="(mode, index) in modes" :key="index" class="pa-0" xs6>
                        <v-btn flat block>
                            <span>{{ mode.name }}</span>
                        </v-btn>
                    </v-flex>
                </v-btn-toggle>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import ForecastingItemModes from '@/helpers/forecastingItemModes'

export default {
    components: {

    },
    props: {
        value: {
            type: Number,
            required: true
        }
    },
    data(){
        return {

        };
    },
    computed: {
        modes(){
            return Object.keys(ForecastingItemModes).map(x => {
                if(ForecastingItemModes[x] === ForecastingItemModes.Detail){
                    return {
                        name: "Details"
                    };
                }

                if(ForecastingItemModes[x] === ForecastingItemModes.Notes){
                    return {
                        name: "Notes/Alert"
                    };
                }

                if(ForecastingItemModes[x] === ForecastingItemModes.Profile){
                    return {
                        name: "Edit Profile"
                    };
                }
            });
        },
        selectedValue(){
            return Object.keys(ForecastingItemModes).findIndex(
                x => ForecastingItemModes[x] === this.value
            );
        }
    },
    methods: {
        handleValueChanged(value){
            let modeSelected = Object.keys(ForecastingItemModes)[value];

            this.update(ForecastingItemModes[modeSelected]);
        },
        update(value){
            this.$emit("input", value);
        }
    },
    created(){

    }
}
</script>

<style scoped>
.rounded-btn-group {
    border-radius: 4px;
    border: 2px solid rgba(0,0,0,0.54);
    margin-bottom: 0px;
    box-shadow: none;
    -webkit-box-shadow: none;
}

.rounded-btn-group .v-btn {
    padding: 16px 20px;
    height: 56px;
    width: 100%;
}

.rounded-btn-group:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
}

.rounded-btn-group:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}
</style>